<template>   
    <div class="related-recipe-card" @click="openNewWindow(item.Url)">
        <div class="card bg-quaternary">
            <div class="card-media">
                <img :src="image" alt="" />
            </div>

            <div class="card-category-tag-group">
                <div v-for="value in category" class="card-category-tag callout-card-cta" :class="['card-' + value.Text.toLowerCase()]">{{ value.Text }}</div>
            </div>
            
            <div class="card-inner bg-quaternary">
                <div>
                    <a v-bind:href="item.Url" target="_blank" class="card-title">{{ item.Title }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import imageOptimizer from '../../utils/image-optimizer.js';

	export default {
		props: ['item'],
        data: function() {
          return {
            category: [],
          };
        },
		components: {
            
        },
        computed: {
            typeTags: function () {
                return this.item.Tags.filter(function (item) {
                    return item.Type.CodeName == 'Types';
                })
            },
            image: function () {
                let html = document.querySelector('html');

                if (html.classList.contains('webp')){
                    if ($(window).width() < 768 && this.item.ImageMobile !== null && this.item.ImageMobile !== undefined && this.item.ImageMobile !== "") {
                        return imageOptimizer.getOptimizedImageUrl(this.item.ImageMobile, 'webp');
                    }
                    else if (this.item.Image !== null && this.item.Image !== "") {
                        return imageOptimizer.getOptimizedImageUrl(this.item.Image, 'webp');
                    }
                    else {
                        return '/Content/images/Custom/recipe-placeholder.webp';
                    }
                }
                else {
                    if ($(window).width() < 768 && this.item.ImageMobile !== null && this.item.ImageMobile !== undefined && this.item.ImageMobile !== "") {
                        return imageOptimizer.getSanitizeMediaUrl(this.item.ImageMobile);
                    }
                    else if (this.item.Image !== null && this.item.Image !== "") {
                        return imageOptimizer.getSanitizeMediaUrl(this.item.Image);
                    }
                    else {
                        return '/Content/images/Custom/recipe-placeholder.png';
                    }
                }
            }
        },
		mounted: function () {
            this.handleCardType();
		},
        methods: {
            handleCardType() {
                for(let tag of this.item.Tags) {
                    if (tag.Type.CodeName.includes('MealTypes')) {
                        this.category.push(tag);
                    }
                }
                return this.category;
            },
            openNewWindow(url) {
                window.open(url, '_blank');
            }
        },
        filters: {
            checkImage: function (value) {
                if (value !== null && value !== "") {
                    return value.replace("~", "");
                }
                else {
                    return "/Content/images/recipe-placeholder.png";
                }
            }
        }
    }
</script>